module.exports = __webpack_public_path__ + "img/logo.e9ff641f.png";